// extracted by css-extract-rspack-plugin
module.exports =  {"root":"DocumentsTab__root___lncx9","workspaceFilter":"DocumentsTab__workspaceFilter___bYN5I","documentsTable":"DocumentsTab__documentsTable___QNYqQ"};